import React from "react";
import {freshdeskTicketDisplay, freshdeskTicketUrl, isPendingFreshdeskTicket} from "utils/freshdeskTicket";

export default function FreshdeskTicketLink({freshTicket, className}) {
	if (isPendingFreshdeskTicket(freshTicket)) {
		return <span className={className}>{freshdeskTicketDisplay(freshTicket)}</span>;
	}

	if (!freshTicket) {
		return <span className={className}>N/A</span>;
	}

	return (
		<a className={className} href={freshdeskTicketUrl(freshTicket)} target="_blank" rel="noopener noreferrer">
			{freshTicket}
		</a>
	);
}
